export default "assets/images/statue-6f21f813.png";